<template>
	<div class="chart">
		<div ref="chart" style="width: 100%; height: 100%;"></div>
	</div>
</template>

<script>
	export default {
		name: 'chart',
		props: {
			option: {
				type: Object,
				default: () => {}
			},
			labels: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {
				chart: null
			}
		},
		mounted() {
			this.chart = this.$chart.init(this.$refs.chart)
			this.chart.setOption(this.option)
			this.chart.off('click')
			this.chart.on('click', (params)=> {
				this.$emit("areaClick", params.name);
			})
		},
		watch: {
			option:{
				handler(option) {
					this.chart.setOption(this.option)
				},
				deep: true
			}
		},
		beforeDestroy() {
			if (!this.chart) {
				return;
			}
			this.chart.dispose();
			this.chart = null;
		},
	}
</script>

<style lang="less" scpoed>
	.chart {
		width: 100%;
		height: 100%;
		position: relative;
	}
	.labels {
		width: 100%;
		height: 40px;
		position: absolute;
		bottom: 0;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		align-items: center;
		font-size: 14px;
		.label {
			label {
				margin: 0 10px;
			}
		}
	}
</style>
